import React from "react"
import { Asset, Link } from "../../../plugins/gatsby-plugin-atollon"
import parse from 'html-react-parser'
import { Arrow } from "../icons"

const ProjectCard = (props) => {

  if  (!props) {
    return null
  }

  let tags = [...(props.servicesTags ?? []), ...(props.sectors ?? [])];

  return (
    <Link to={props.permalink} className="card card--project">
      <div className="card--project__image">
        {props.thumbnail && <Asset asset={props.thumbnail} />}
      </div>

      <div className="card--project__info">
        {props.categories?.length > 0 && <span>{props.categories[0].title}</span>}
        {props.title && <h3>{parse(props.title)}</h3>}
        {props.permalink && <span to={props.permalink}><Arrow/></span>}
        { tags?.length > 0 &&
          <ul>
            {tags.slice(0, 4).map((tag, index) => (
              <li key={index}>{tag.title}</li>
            ))}
          </ul>
        }
      </div>
    </Link>
  )
}

export default ProjectCard
